import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { server } from "../server";

function VerifyOTP() {
  const location = useLocation();
  const navigate = useNavigate();
  const { phone, email } = location.state || {};
  const loginMethod = email ? "email" : "phone";
  const identifier = email || phone;

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!phone && !email) {
      navigate("/", { replace: true });
    }
  }, [phone, email, navigate]);

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpValue = otp.join("");

    const payload =
      loginMethod === "phone"
        ? { phone: Number(phone), otp: Number(otpValue), role: "user" }
        : { email, otp: Number(otpValue), role: "user" };

    try {
      setLoading(true);

      const response = await fetch(`${server}/Auth/VerifyOtp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("authToken", data.token);
        localStorage.setItem(loginMethod, identifier);

        const redirectPath = localStorage.getItem("redirectAfterLogin");
        const authIntentRaw = localStorage.getItem("authRedirectIntent");

        if (redirectPath) {
          localStorage.removeItem("redirectAfterLogin");
          navigate(redirectPath);
        } else if (authIntentRaw) {
          try {
            const intent = JSON.parse(authIntentRaw);
            localStorage.removeItem("authRedirectIntent");
            navigate(intent.target || "/dashboard");
          } catch {
            navigate("/dashboard");
          }
        } else {
          navigate("/dashboard");
        }
      } else {
        alert(data.message || "OTP verification failed ❌");
      }
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const maskedIdentifier =
    loginMethod === "phone"
      ? `(+91) ${phone}`
      : email.replace(/(.{2}).+(@.+)/, "$1****$2");

  return (
    <section className="verify-otp vh-100 d-flex align-items-center">
      <div className="container position-relative z-3">
        <div className="row align-items-center justify-content-center g-0">
          <div className="col-lg-5 col-md-12">
            <div className="p-7 w-100 login-bg rounded-5 overflow-hidden">
              <div className="d-flex flex-column align-items-center">
                <Link to="/">
                  <img
                    src="/assets/images/logo.png"
                    className="mb-3"
                    alt="logo-icon"
                    width="130"
                  />
                </Link>

                <div className="gap-1">
                  <h3 className="mb-0 fw-bold text-white lh-sm text-center">
                    Verify OTP
                  </h3>

                  <span className="text-light text-center d-block">
                    During signup, an OTP will be sent to both your phone and
                    email.
                  </span>
                  <span className="text-light text-center d-block">
                    {loginMethod === "phone"
                      ? "OTP sent to mobile"
                      : "OTP sent to email"}
                    <span className="ms-1 fw-semibold">{maskedIdentifier}</span>
                  </span>
                </div>

                <form className="needs-validation mt-4" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <div className="d-flex align-items-center gap-1">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-${index}`}
                          type="text"
                          value={digit}
                          onChange={(e) => handleChange(e, index)}
                          className="form-control fs-4 text-white otp-box bg-transparent light-border rounded-3 text-center"
                          placeholder=""
                          maxLength="1"
                          autoComplete="nope"
                        />
                      ))}
                    </div>
                  </div>
                  <button
                    type="submit"
                    disabled={loading || otp.join("").length !== 4}
                    className="btn btn-gradient-bg-2 border-0 text-white rounded-3 px-6 mt-1 btn-md w-100"
                  >
                    {loading ? (
                      <div
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></div>
                    ) : (
                      "Continue"
                    )}
                  </button>
                </form>

                <div className="mt-3 text-center">
                  <a href="#" className="fs-5 lh-1">
                    Need Help ? Contact Us
                  </a>
                </div>

                <div className="mt-5 d-flex justify-content-center gap-2">
                  <img src="/assets/images/btn-appstore.svg" width="145" />
                  <img src="/assets/images/btn-g-play.svg" width="145" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VerifyOTP;
